import styled from 'styled-components'

// Sin animaciones de label y borde: el selector vive en filas de tabla que se re-renderizan.
// Altura, borde, radio y fuente salen del tema (MuiOutlinedInput / MuiAutocomplete).
export const SelectChangeStatusTemplateRequestNotGroupStyle = styled.div`
  .MuiInputLabel-animated {
    transition: none !important;
  }

  .MuiInputBase-input {
    animation: none !important;
    animation-name: none !important;
  }

  .MuiOutlinedInput-notchedOutline legend {
    transition: none !important;
  }
`
